// extracted by mini-css-extract-plugin
export var large = "video-module--large--790db";
export var video = "video-module--video--5a464";